/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
export default {
  COLOR_RED: "#ef4748",
  COLOR_YELLOW: "#f7ec39",
  COLOR_FOREST: "#00965f",
  COLOR_BLUE: "#49b8ff",
  COLOR_PLUM: "#8c0d70",
  COLOR_CORAL: "#ff7132",
  COLOR_LIME: "#d8e25b",
  COLOR_TEAL: "#00beaf",
  COLOR_NAVY: "#001958",
  COLOR_MAGENTA: "#d256a0",
  COLOR_GREEN: "#84da59",
  COLOR_DENIM: "#6d95cc",
  COLOR_INDIGO: "#370850",
  COLOR_PINK: "#ff72a4"
}